import React, { Component } from "react"
import { translate } from "react-translate"
import { Icon, Grid, Dropdown } from "semantic-ui-react"
import "./Devis.css"
import _ from "lodash"

const options = [
  {
    key: 0,
    text: "value_dropdown_brouillon",
    value: 0,
    icon: "file outline"
  },
  {
    key: 1,
    text: "value_dropdown_accepté",
    value: 1,
    icon: "check circle outline"
  },
  { key: 2, text: "value_dropdown_finalisé", value: 2, icon: "download" },
  { key: 3, text: "value_dropdown_abandonné", value: 3, icon: "hdd outline" }
]

class DevisLine extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: 0
    }
  }

  componentWillMount() {
    let { t } = this.props
    var optionsCopy = _.clone(options)
    optionsCopy = _.map(optionsCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })

    this.setState({
      options: optionsCopy
    })
  }

  render() {
    let { t } = this.props
    const { icons, reference, name, adress, price, date, statut } = this.props
    var status = options[statut] || {
      key: 0,
      text: "value_dropdown_choisir",
      value: 0
    }
    return (
      <Grid columns="equal" id="devisDiv">
        <Grid.Row>
          <Grid.Column>
            <Icon id="iconDevis" name={icons} />
            {reference}
          </Grid.Column>
          <Grid.Column>
            {<Icon id="iconDevis" name="user outline" />}
            {name}
          </Grid.Column>
          <Grid.Column>
            {<Icon id="iconDevis" name="map pin" />}
            {adress}
          </Grid.Column>
          <Grid.Column id="price">{price + "€"}</Grid.Column>
          <Grid.Column id="dateBold">{date}</Grid.Column>
          <Grid.Column>
            <Dropdown
              selection
              icon={status.icon}
              id="dropdownDevis"
              onChange={(e, val) => {
                this.props.handleRowDropdownChange(e, val)
              }}
              options={this.state.options || []}
              value={status.value}
              text={t(status.text)}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

export default translate("ProDevisLine")(DevisLine)



// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/BodyDevisEtFactures/Devis.jsx